export const DEFAULT_REPORT_STYLE={primary:'#0f172a',accent:'#0891b2',sectionOne:'#b45309',sectionTwo:'#0369a1',furtherInspection:'#64748b',bodySize:10,photoColumns:3,diagramBackground:'tint',photoCaptions:true};
export const REPORT_STYLE_PRESETS=[
 {name:'SpecTermite',colors:{primary:'#0f172a',accent:'#0891b2',sectionOne:'#b45309',sectionTwo:'#0369a1',furtherInspection:'#64748b'}},
 {name:'Forest',colors:{primary:'#163c34',accent:'#147d64',sectionOne:'#8b4d23',sectionTwo:'#285f77',furtherInspection:'#66756a'}},
 {name:'Classic blue',colors:{primary:'#183451',accent:'#276fa3',sectionOne:'#8a5526',sectionTwo:'#276fa3',furtherInspection:'#61758a'}},
 {name:'Monochrome',colors:{primary:'#202020',accent:'#454545',sectionOne:'#333333',sectionTwo:'#555555',furtherInspection:'#777777'}}
];
export const validReportColor=value=>typeof value==='string'&&/^#[0-9a-f]{6}$/i.test(value);
export function normalizeReportStyle(value={}){
 const next={...DEFAULT_REPORT_STYLE};
 for(const key of ['primary','accent','sectionOne','sectionTwo','furtherInspection'])if(validReportColor(value?.[key]))next[key]=value[key].toLowerCase();
 if([9,10,11].includes(Number(value?.bodySize)))next.bodySize=Number(value.bodySize);
 if([2,3,4].includes(Number(value?.photoColumns)))next.photoColumns=Number(value.photoColumns);
 if(['white','grid','tint'].includes(value?.diagramBackground))next.diagramBackground=value.diagramBackground;
 if(typeof value?.photoCaptions==='boolean')next.photoCaptions=value.photoCaptions;
 return next;
}
export function reportRGB(hex){return [1,3,5].map(start=>parseInt(hex.slice(start,start+2),16));}
export function reportTint(hex,amount=.08){return reportRGB(hex).map(v=>Math.round(255*(1-amount)+v*amount));}
export function reportInk(hex){
 const [r,g,b]=reportRGB(hex).map(v=>{v/=255;return v<=.04045?v/12.92:Math.pow((v+.055)/1.055,2.4);});
 return .2126*r+.7152*g+.0722*b>.179?'#152238':'#ffffff';
}
export const reportCategoryColor=(style,cat)=>cat<=3?style.sectionOne:cat===4?style.sectionTwo:style.furtherInspection;

// Brand fills retain the chosen color; small text is darkened when needed on white paper.
export function reportTextColor(hex){
 let rgb=reportRGB(hex),color=hex;
 for(let i=0;i<8&&reportInk(color)==='#152238';i++){rgb=rgb.map(v=>Math.round(v*.8));color='#'+rgb.map(v=>v.toString(16).padStart(2,'0')).join('');}
 return color;
}
